/* eslint-disable relay/unused-fields */
import fetch from '@adeira/fetch';
import { format } from '@kiwicom/useragent';
import { graphql } from '@kiwicom/account-relay';

import type { fetchUserInfoQuery$data as Response } from './__generated__/fetchUserInfoQuery.graphql';

// relay-compiler generate types from this string wrapped in gql literal
// it can't be used in request body so query string is defined under this
// eslint-disable-next-line
const TokenUserQuery = graphql`
  query fetchUserInfoQuery {
    viewer {
      __typename
      ... on Unauthorized {
        reason
      }
      ... on User {
        locale {
          language {
            languageId
          }
          currency {
            code
          }
        }
        hasPassword
      }
    }
  }
`;
// string is used in request body as query
const TokenUserQueryString = `
  query fetchUserInfoQuery {
    viewer {
      __typename
      ... on Unauthorized {
        reason
      }
      ... on User {
        locale {
          language {
            languageId
          }
          currency {
            code
          }
        }
        hasPassword
      }
    }
  }
`;
const fetchUserInfo = async (authToken: string): Promise<Response | null> => {
  const response = await fetch('https://plexus-prod.skypicker.com/graphql', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken}`,
      'X-Client': 'Account-FE',
      'User-Agent': format(
        'account-frontend',
        process.env.NEXT_PUBLIC_COMMIT_SHORT_SHA,
        process.env.APP_ENV,
      ),
    },
    body: JSON.stringify({
      query: TokenUserQueryString,
    }),
  });

  const {
    data,
  }: {
    data: Response | null;
  } = await response.json();

  if (data?.viewer?.__typename === 'Unauthorized') {
    throw new Error(data.viewer.reason);
  }

  return data;
};

export default fetchUserInfo;
